import styled from "styled-components";

const LanguageSwitcherWrapper = styled.div`
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin: 0;
      padding: 0 10px;
    }
    svg {
      height: 20px;
      width: auto;
    }
  }
  .list {
    p {
      margin: 0;
      padding: 5px 10px;
      cursor: pointer;
    }
  }
`;

export default LanguageSwitcherWrapper;
